document.addEventListener("DOMContentLoaded", () => {

    try {
        // inicializa funcionalidades essenciais
        init_form_behavior();
        var firstEmailValid = true;

        const firstFormData = JSON.parse(sessionStorage.getItem('preAdesao'));

        if (!firstFormData) {
            window.location.href = '/';
        } else {
            document.querySelector('#adesao-nome').value = firstFormData.nome;
            document.querySelector('#adesao-nascimento').value = firstFormData.nascimento;
            document.querySelector('#adesao-telefone').value = firstFormData.telefone;
            document.querySelector('#adesao-email').value = firstFormData.email;
        }

        // Comportamento das abas clicáveis
        const stepChanger = document.querySelectorAll(".change-step");
        stepChanger.forEach(step => {
            step.onclick = (e) => {
                if (step.classList.contains("disabled") || step.classList.contains("current")) {
                    return false;
                } else {
                    let target = e.target.getAttribute('href');

                    // Troca o estado das abas
                    document.querySelector(".change-step.current").classList.remove('current');
                    step.classList.add('current');

                    // Troca o estado das etapas do form
                    document.querySelector(".form-step.active").classList.remove('active');
                    document.querySelector(`.form-step${target}`).classList.add('active');
                }
            }
        });

        // Comportamento do seletor de contratação
        const contratacao = document.querySelectorAll('input[name="adesao_contratacao"]');
        contratacao.forEach(input => {
            input.addEventListener('change', (e) => {
                const valor = e.target.value;
                const btnDependente = document.querySelector('button.add-dependente');
                const dependenteContainer = document.querySelector('#dependentes-container');

                if (valor == 'Para minha família') {
                    btnDependente.classList.remove('disabled');
                    toggleRequiredInputs('add');
                    init_form_behavior();
                } else {
                    btnDependente.classList.add('disabled');
                    dependenteContainer.classList.add('disabled')
                    toggleRequiredInputs('remove');
                    init_form_behavior();
                }

            });
        });

        // Comportamento de iniciar adição de dependentes
        const btnAddDependente = document.querySelector('button.add-dependente');
        btnAddDependente.addEventListener('click', (e) => {

            const dependentesContainer = document.querySelector('#dependentes-container');
            dependentesContainer.classList.toggle('disabled');

            if (dependentesContainer.classList.contains('.disabled')) {
                toggleRequiredInputs('remove');
            } else {
                toggleRequiredInputs('add');
            }

            // Inicia novamente o comportamento do form
            init_form_behavior();

        });

        // Botão de adicionar mais dependentes
        document.getElementById('mais-dependentes').addEventListener('click', () => {
            const container = document.getElementById('dependentes-container');
            const dependentes = container.querySelectorAll('.dependente');
            const ultimoIndice = dependentes.length; // Último índice baseado na contagem atual
            const ultimoDependente = dependentes[dependentes.length - 1];

            if (ultimoDependente) {
                // Clone o último dependente
                const novoDependente = ultimoDependente.cloneNode(true);

                // Atualiza os índices dos elementos no clone
                const novoIndice = ultimoIndice + 1; // Soma 1 ao índice atual
                novoDependente.querySelector('h2 span').textContent = novoIndice;

                // Atualiza os atributos e nomes dos inputs e selects
                novoDependente.querySelectorAll('input, select').forEach(input => {
                    if (input.id) {
                        input.id = input.id.replace(/\d+$/, novoIndice); // Substitui o índice antigo pelo novo
                    }
                    if (input.name) {
                        input.name = input.name.replace(/\d+$/, novoIndice); // Substitui o índice antigo pelo novo
                    }

                    // Só limpa se não for radio
                    if (!(input.type === 'radio') && !(input.type === 'select')) {
                        input.value = '';
                    }

                });

                // Insere o novo dependente antes do botão
                container.insertBefore(novoDependente, document.getElementById('mais-dependentes'));
            }
        });

        // Seleciona o elemento que será observado
        const targetNode = document.querySelector('#dependentes-container');
        // Configuração do observer para observar alterações nos filhos (adição ou remoção)
        const config = {
            childList: true, // Observar adição ou remoção de elementos
            subtree: false   // Não observar mudanças nos filhos dos filhos
        };

        // Callback executado quando mudanças são detectadas
        const callback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    init_form_behavior();
                    toggleRequiredInputs('add');
                    break; // Chamamos a função uma vez e saímos
                }
            }
        };
        // Cria o MutationObserver e inicia a observação
        const observer = new MutationObserver(callback);
        // Inicia a observação do elemento
        if (targetNode) {
            observer.observe(targetNode, config);
        } else {
            console.error("Elemento #dependentes-container não encontrado.");
        }

        // Seleciona todos os elementos com a classe .file-box-interactive
        const fileBoxElements = document.querySelectorAll(".file-box-interactive");
        // Adiciona um listener de clique a cada elemento
        fileBoxElements.forEach(fileBox => {
            const fileInput = fileBox.querySelector(".file-box-interactive input");

            if (fileInput) {
                // Adiciona listener para mudanças no input, garantindo que ele seja registrado apenas uma vez
                fileInput.addEventListener("change", () => {
                    // Encontra o .doc-selection que é um irmão no mesmo nível
                    const docSelection = fileBox.parentElement.querySelector(".doc-selection");

                    if (docSelection) {
                        const spanElement = docSelection.querySelector("span");

                        if (fileInput.files && fileInput.files.length > 0) {
                            const fileName = fileInput.files[0].name; // Obtém o nome do arquivo selecionado
                            docSelection.classList.add("selected");

                            if (spanElement) {
                                spanElement.innerText = fileName; // Define o texto do span como o nome do arquivo
                            }
                        } else {
                            docSelection.classList.remove("selected");

                            if (spanElement) {
                                spanElement.innerText = "Nenhum arquivo selecionado"; // Define texto padrão
                            }
                        }
                    }
                });

                // Adiciona o clique no elemento pai
                fileBox.addEventListener("click", () => {
                    fileInput.click();
                });

                // Adiciona listener de clique no .doc-selection para limpar o valor do input
                const docSelection = fileBox.parentElement.querySelector(".doc-selection");

                if (docSelection) {
                    docSelection.addEventListener("click", (e) => {
                        e.preventDefault();
                        fileInput.value = ""; // Remove o valor do input
                        docSelection.classList.remove("selected"); // Remove a classe selected

                        const spanElement = docSelection.querySelector("span");
                        if (spanElement) {
                            spanElement.innerText = "Nenhum arquivo selecionado"; // Define texto padrão
                        }
                    });
                }
            }
        });

        // Autopreencher de CEP
        document.querySelector('#adesao-cep').addEventListener('blur', (e) => {
            let cep = e.target.value;

            fetch(`https://viacep.com.br/ws/${cep}/json`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Erro na requisição: ${response.status}`);
                    }
                    return response.json(); // Converte a resposta para JSON
                })
                .then(data => {
                    console.log(data); // Mostra o JSON retornado no console
                    if (data.erro) {
                        alert('Digite o CEP corretamente e tente novamente');
                    } else {
                        document.querySelector('#adesao-logradouro').value = data.logradouro;
                        document.querySelector('#adesao-bairro').value = data.bairro;
                        document.querySelector('#adesao-cidade').value = data.localidade;
                        document.querySelector('#adesao-estado').value = data.uf;

                        if (!data.logradouro || !data.bairro || !data.localidade || !data.uf) {
                            ['#adesao-logradouro', '#adesao-bairro', '#adesao-cidade'].forEach(selector => {
                                const el = document.querySelector(selector);
                                if (el) {
                                    el.removeAttribute('readonly');
                                    el.classList.add('destacado');
                                }
                            });
                        }
                    }
                })
                .catch(error => {
                    console.log(`Erro: ${error.message}`);
                });
        });

        const form = document.querySelector('#form-aderir-plano');
        const results = document.querySelector('#adesao-concluir');

        const plano = {
            id: form.querySelector('#btn-enviar-adesao').getAttribute('data-plan'),
            nome: document.querySelector('.card-plano h3').innerText,
            preco: document.querySelector('.card-plano .price-plano').innerText
        };

        form.addEventListener('submit', async (s) => {
            s.preventDefault();
            const btnSubmit = document.querySelector("#btn-enviar-adesao");

            // Faz a captura dos dependentes
            let dadosDependentes = get_dependentes();
            const dependenteContainer = document.querySelector('#dependentes-container');

            let dependentesRequest = {
                "type": "root",
                "children": dadosDependentes
            };

            console.log(
                dependentesRequest
            );

            if (dependenteContainer.classList.contains('disabled')) {
                dependentesRequest = {
                    "type": "root",
                    "children": []
                };
            }

            btnSubmit.classList.add('waiting');

            // Faz envio dos documentos
            const resultadoDocumentos = await enviarArquivosComEmail();

            // Verifica se os documentos foram salvos
            if (resultadoDocumentos) {

                const dadosForm = {
                    codigo_do_produto: btnSubmit.getAttribute('product-code'),
                    email: form.querySelector('#adesao-email').value,
                    emailAlternativo: form.querySelector('#email-alternativo').value,
                    firstEmailValid: firstEmailValid,
                    cpf: form.querySelector('#adesao-cpf').value,
                    cep: form.querySelector('#adesao-cep').value,
                    bairro: form.querySelector('#adesao-bairro').value,
                    numero_endereco: form.querySelector('#adesao-numero').value,
                    sexo: form.querySelector('select[name="adesao_sexo"]').value,
                    servidor_publico: form.querySelector('input[name="adesao_servidor"]:checked').value,
                    contratacao: form.querySelector('input[name="adesao_contratacao"]:checked').value,
                    nome_mae: form.querySelector('#adesao-nome-mae').value,
                    nascimento: form.querySelector('#adesao-nascimento').value,
                    telefone: form.querySelector('#adesao-telefone').value,
                    ipe: form.querySelector('input[name="adesao_ipe"]:checked').value,
                    estado_civil: form.querySelector('select[name="adesao_estado_civil"]').value,
                    plano: plano.id,
                    dependentes: dependentesRequest,
                    adesao_doc_frente: resultadoDocumentos.urls.arquivo1,
                    adesao_doc_verso: resultadoDocumentos.urls.arquivo2,
                    adesao_contracheque: resultadoDocumentos.urls.arquivo3,
                    codigo_de_vendedor: form.querySelector('#adesao-vendedor').value || "",
                    shippingAddress: {
                        name: form.querySelector('#adesao-nome').value,
                        address1: form.querySelector('#adesao-logradouro').value,
                        numero: form.querySelector('#adesao-numero').value,
                        address2: form.querySelector('#adesao-complemento').value || "",
                        city: form.querySelector('#adesao-cidade').value,
                        province: form.querySelector('#adesao-estado').value,
                        zip: form.querySelector('#adesao-cep').value,
                        country: "BR"
                    },
                }

                fetch('https://nodejs.crpmango.com.br/shopify/create-order', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dadosForm),
                })
                    .then(async response => {
                        const contentType = response.headers.get('content-type');
                        const responseBody = contentType && contentType.includes('application/json')
                            ? await response.json()
                            : await response.text();

                        if (!response.ok || responseBody.success === false) {
                            btnSubmit.classList.remove('waiting');
                            throw {
                                status: response.status,
                                statusText: response.statusText,
                                body: responseBody
                            };
                        }

                        return responseBody;
                    })
                    .then(async data => {
                        console.log('Cliente criado com sucesso:', data);
                        results.querySelector('#listagem-valor span').innerText = plano.nome;
                        results.querySelector('#listagem-plano span').innerText = plano.preco;
                        results.querySelector('#listagem-servidor-publico span').innerText = dadosForm.servidor_publico ? 'Sim' : 'Não';
                        results.querySelector('#listagem-contratacao span').innerText = dadosForm.contratacao;
                        results.querySelector('#listagem-ipe span').innerText = dadosForm.ipe ? 'Sim' : 'Não';
                        results.querySelector('#listagem-nascimento span').innerText = dadosForm.nascimento;
                        results.querySelector('#listagem-cpf span').innerText = dadosForm.cpf;
                        results.querySelector('#listagem-telefone span').innerText = dadosForm.telefone;
                        results.querySelector('#listagem-email span').innerText = dadosForm.email;
                        results.querySelector('#listagem-estado-civil span').innerText = dadosForm.estado_civil;
                        results.querySelector('#listagem-endereco span').innerText = `${dadosForm.shippingAddress.address1} - ${dadosForm.shippingAddress.zip} | ${dadosForm.shippingAddress.address2 || "Sem Complemento"}`;

                        form.classList.toggle('hidden');
                        document.querySelector('.side-card').classList.toggle('hidden');
                        results.classList.toggle('hidden');
                    })
                    .catch(error => {
                        console.error('Erro geral:', error);

                        let errorMessage = 'Ocorreu um erro no formulário, tente novamente mais tarde.';

                        if (error.body && typeof error.body.message === 'string') {
                            if (error.body.message.includes('Email contains an invalid domain name')) {
                                errorMessage = 'Domínio de e-mail informado no cadastro é inválido, use outro.';
                                firstEmailValid = false;
                                form.querySelector('label[for="email-alternativo"]').classList.remove('hidden');
                                form.querySelector('label[for="email-alternativo"] input').setAttribute('required', 'required');
                            } else {
                                errorMessage = error.body.message;
                                alert(errorMessage);
                            }
                        }
                    });
            }
        });

    } catch (error) {
        console.log(error);
        btnSubmit.classList.remove('waiting');
    }

});

function get_dependentes() {

    let dependentesData = [];

    const dependentes = document.querySelectorAll('#dependentes-container .dependente');
    dependentes.forEach(dep => {
        dependentesData.push({
            "type": "paragraph",
            "children": [
                // Nome Completo
                {
                    "type": "text",
                    "value": "Nome Completo: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('.campo[data-type="nome"]').value} \n`
                },
                // Data de Nascimento
                {
                    "type": "text",
                    "value": `Data de nascimento: `,
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${convertDataFormat(dep.querySelector('.campo[data-type="nascimento"]').value)} \n`
                },
                // CPF
                {
                    "type": "text",
                    "value": "CPF: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('.campo[data-type="cpfDependente"]').value} \n`
                },
                // Parentesco
                {
                    "type": "text",
                    "value": "Parentesco: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('.campo[data-type="parentesco"]').value} \n`
                },
                // Sexo
                {
                    "type": "text",
                    "value": "Sexo: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('.campo[data-type="sexo"]').value} \n`
                },
                // Estado Civil
                {
                    "type": "text",
                    "value": "Estado Civil: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('select[name*="estado_civil_dependente"]').value} \n`
                },
                // Possui Ipe
                {
                    "type": "text",
                    "value": "Possui Ipe: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('input[data-type="ipe-dependente"]:checked').value} \n`
                },
                // Servidor Público
                {
                    "type": "text",
                    "value": "Servidor Público: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('input[data-type="servidor-dependente"]:checked').value} \n`
                },
                // Nome da Mãe
                {
                    "type": "text",
                    "value": "Nome da Mãe: ",
                    "bold": true
                },
                {
                    "type": "text",
                    "value": `${dep.querySelector('.campo[data-type="nomeMae"]').value}`
                }
            ]
        });
    });

    return dependentesData;
}

function convertDataFormat(data) {
    const [dia, mes, ano] = data.split('/');
    const novaData = `${ano}${mes}${dia}`;
    return novaData;
}

function init_form_behavior() {
    // Inicia as máscaras de campos
    $('.birthday').mask('00/00/0000');
    $('.phone').mask('(00) 00000-0000');
    $('.cpf').mask('00000000000');
    $('.cep').mask('00000000');
    aplicarCaixaAlta('input[data-type="nome"], input[data-type="nomeMae"], #adesao-nome-mae');
    aplicarCaixaAlta('input[data-type="nascimento"]');

    // Validação dos campos de nome
    $('input[data-type="nome"], input[data-type="nomeMae"], #adesao-nome-mae').on('blur', function (e) {
        let nomeValido = validarNomeCompleto($(this).val());
        if (!nomeValido) {
            $(this).val('');
            $(this).addClass('erro-campo');
            $(this).parent().find('.erro').show();
        } else {
            $(this).removeClass('erro-campo');
            $(this).parent().find('.erro').hide();
        }
    });

    // Validação dos campos de data de nascimento
    $('input[data-type="nascimento"]').on('blur', function (e) {
        let nascimentoValido = validarDataNascimento($(this).val());
        if (!nascimentoValido) {
            $(this).val('');
            $(this).addClass('erro-campo');
            $(this).parent().find('.erro').show();
            init_form_behavior();
        } else {
            $(this).removeClass('erro-campo');
            $(this).parent().find('.erro').hide();
        }
    });

    // Validação dos campos de CPF
    $('#adesao-cpf, input[data-type="cpfDependente"]').on('blur', function (e) {

        // Verifica se os CPFs são iguais ao do Titular
        let cpfsDependentes = [];
        let cpfTitular = $('#adesao-cpf').val();

        $('input[data-type="cpfDependente"]').each(function () {
            let $this = $(this);
            let cpf = $this.val();
            let erroEl = $this.parent().find('.erro');
            let erroTextOriginal = erroEl.text();

            // Armazena o texto original, se ainda não estiver salvo
            erroEl.data('original', erroTextOriginal);

            let erro = '';

            if (cpf === cpfTitular) {
                erro = 'O CPF do titular não pode ser igual ao do dependente.';
            } else if (cpfsDependentes.includes(cpf)) {
                erro = 'Cada dependente deve ter um CPF único.';
            }

            if (erro) {
                $this.val('');
                $this.addClass('erro-campo');
                erroEl.show().text(erro);
            } else {
                cpfsDependentes.push(cpf);
                $this.removeClass('erro-campo');
                erroEl.hide().text(erroTextOriginal);
            }
        });


        // Valida CPF para cada campo
        let cpfValido = validarCPF($(this).val());
        if (!cpfValido) {
            $(this).val('');
            $(this).addClass('erro-campo');
            $(this).parent().find('.erro').show();
            init_form_behavior();
        } else {
            $(this).removeClass('erro-campo');
            $(this).parent().find('.erro').hide();
        }

    });

    // Comportamento das abas de formulários e seus inputs
    const formSteps = document.querySelectorAll(".form-step");

    formSteps.forEach(formStep => {
        const inputs = formStep.querySelectorAll("input[required], select[required]");
        const continueBtn = formStep.querySelector(".continue-btn, #btn-enviar-adesao");
        //continueBtn.classList.add('disabled');


        // Verifica se todos os campos obrigatórios estão preenchidos
        const allFilled = [...inputs].every(input => input.value.trim());
        if (allFilled) {
            // Todos preenchidos
            continueBtn.classList.remove('disabled');
        }

        continueBtn.onclick = (e) => {
            // Verifica se o botão é o de finalizar formulário
            if (!continueBtn.id.includes('btn-enviar-adesao')) {
                e.preventDefault();

                // Verifica se todos os campos obrigatórios estão preenchidos
                let allFilled = true;

                inputs.forEach(input => {
                    if (input.value.trim() === "") {
                        input.classList.add("erro-campo");
                        input.classList.remove("destacado");

                        allFilled = false;
                    } else {
                        input.classList.remove("erro-campo");
                    }

                });

                if (allFilled) {
                    const btnTarget = continueBtn.getAttribute('href');
                    formStep.classList.remove('active');

                    document.querySelector(`.form-step${btnTarget}`).classList.add('active');
                    document.querySelector(`.change-step.current`).classList.remove('current');

                    document.querySelector(`.change-step[href="${btnTarget}"]`).classList.remove('disabled');
                    document.querySelector(`.change-step[href="${btnTarget}"]`).classList.add('current');
                } else {
                    return false;
                }

            }
        };
    });


    // Botão de remover dependentes
    const btnremoveDependente = document.querySelectorAll('.remover-dependente');
    btnremoveDependente.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const dependente = e.target.closest('.dependente'); // Encontra o dependente mais próximo
            dependente.remove(); // Remove o elemento dependente
        });
    });

}

// Função para alternar o required dos inputs
function toggleRequiredInputs(operation) {
    const dependentesContainer = document.querySelector('#dependentes-container');
    const inputs = dependentesContainer.querySelectorAll('input, select');

    inputs.forEach(input => {
        if (operation == 'remove') {
            input.removeAttribute('required');
        } else {
            input.setAttribute('required', 'required');
        }
    });
}

async function enviarArquivosComEmail() {

    const form = document.querySelector('#form-aderir-plano'); // ou um seletor mais específico, se preferir
    const formData = new FormData();
    const customer = JSON.parse(sessionStorage.getItem('preAdesao'));
    const customerID = customer.customer;

    // Pega o e-mail
    const emailInput = form.querySelector('input[name="adesao_email"]');
    formData.append('email', emailInput.value); // O nome 'email' deve ser o que o backend espera!
    formData.append('customer', customerID);

    const maxSize = 1024 * 1024; // 1 MB em bytes

    // Pega os arquivos dos inputs
    const docFrente = form.querySelector('input[name="adesao_doc_frente"]').files[0];
    const docVerso = form.querySelector('input[name="adesao_doc_verso"]').files[0];
    const contracheque = form.querySelector('input[name="adesao_contracheque"]').files[0];

    if( !docFrente || !docVerso || !contracheque ){
        alert('Verifique se você está enviando todos os documentos e tente novamente.');
    }

    if (docFrente.size > maxSize || docVerso.size > maxSize || contracheque.size > maxSize) {
        alert('Erro no envio dos arquivos. Verifique se os documentos estão nos formatos permitidos (PDF, JPG ou PNG) e não ultrapassam o tamanho máximo de 1MB por arquivo.');
        btnSubmit.classList.remove('waiting');
        return false;
    }

    if (docFrente) formData.append('adesao_doc_frente', docFrente);
    if (docVerso) formData.append('adesao_doc_verso', docVerso);
    if (contracheque) formData.append('adesao_contracheque', contracheque);

    try {
        const response = await fetch('https://nodejs.crpmango.com.br/shopify/save-docs/', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const resultado = await response.json();
        console.log('Resposta do servidor de arquivos:', resultado);
        return resultado;

    } catch (erro) {
        console.error('Erro ao enviar formulário:', erro);

        const btnSubmit = document.querySelector("#btn-enviar-adesao");
        btnSubmit.classList.remove('waiting');
        alert('Erro no envio dos arquivos. Verifique se os documentos estão nos formatos permitidos (PDF, JPG ou PNG) e não ultrapassam o tamanho máximo de 1MB por arquivo.');

        return null;
    }
} 